import React, { useState, useEffect } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    TextField,
    Button,
    Box,
    Autocomplete,
    Chip
} from '@mui/material';
import './UserForm.css';

const AVAILABLE_ROLES = [
    'admin',
    'manager',
    'editor',
    'viewer'
];

const AVAILABLE_ACCESS_LEVELS = [
    'free',
    'premium',
    'vip'
];

const mapInitialData = (data) => {
    if (!data) {
        return {
            name: '',
            email: '',
            roles: [],
            user_subscriptions: []
        };
    }
    return {
        name: data.user_name || data.name || '',
        email: data.user_email || data.email || '',
        roles: data.user_role ? [data.user_role] : [],
        user_subscriptions: data.user_subscriptions || []
    };
};

const UserForm = ({ open, onClose, onSubmit, initialData }) => {
    const [formData, setFormData] = useState(mapInitialData(initialData));

    useEffect(() => {
        setFormData(mapInitialData(initialData));
    }, [initialData, open]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleRolesChange = (event, newValue) => {
        setFormData(prev => ({
            ...prev,
            roles: newValue
        }));
    };

    const handleAccessLevelsChange = (event, newValue) => {
        if (newValue.length === 0) {
            return;
        }
        
        setFormData(prev => ({
            ...prev,
            user_subscriptions: newValue
        }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        onSubmit({
            user_email: formData.email,
            user_name: formData.name,
            user_role: formData.roles[0] || 'user',
            user_subscriptions: formData.user_subscriptions
        });
    };

    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth="sm"
            fullWidth
            className="user-form-dialog"
        >
            <DialogTitle>
                {initialData ? 'Editar Usuário' : 'Novo Usuário'}
            </DialogTitle>
            <form onSubmit={handleSubmit}>
                <DialogContent>
                    <Box className="form-grid">
                        <TextField
                            name="name"
                            label="Nome"
                            value={formData.name || ''}
                            onChange={handleChange}
                            fullWidth
                            required
                        />

                        <TextField
                            name="email"
                            label="Email"
                            type="email"
                            value={formData.email || ''}
                            onChange={handleChange}
                            fullWidth
                            required
                        />

                        <Autocomplete
                            id="roles"
                            options={AVAILABLE_ROLES}
                            value={formData.roles[0] || ''}
                            onChange={(event, newValue) => handleRolesChange(event, [newValue])}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label="Função"
                                    placeholder="Selecione a função"
                                />
                            )}
                        />

                        <Autocomplete
                            multiple
                            freeSolo
                            id="user_subscriptions"
                            options={AVAILABLE_ACCESS_LEVELS}
                            value={formData.user_subscriptions || []}
                            onChange={handleAccessLevelsChange}
                            renderTags={(value, getTagProps) =>
                                value.map((option, index) => {
                                    const { key, ...tagProps } = getTagProps({ index });
                                    const canDelete = value.length > 1;
                                    return (
                                        <Chip
                                            key={key}
                                            label={option}
                                            {...(canDelete ? tagProps : {})}
                                            className="role-chip"
                                            onDelete={canDelete ? tagProps.onDelete : undefined}
                                        />
                                    );
                                })
                            }
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label="Níveis de acesso"
                                    placeholder="Selecione ou digite um nível de acesso"
                                    helperText="Todo usuário deve ter pelo menos um nível de acesso"
                                />
                            )}
                        />
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Button onClick={onClose} color="inherit">
                        Cancelar
                    </Button>
                    <Button type="submit" variant="contained" color="primary">
                        {initialData ? 'Salvar' : 'Criar'}
                    </Button>
                </DialogActions>
            </form>
        </Dialog>
    );
};

export default UserForm; 